import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { useAtom } from 'jotai'

import { ManagerOverviewQueryDocument } from '@docpace/manager-graphql/dist/urql.types'
import { ManagerOverviewQueryResultFragment, ManagerOverviewQueryParams } from '@docpace/manager-graphql'
import { ctxManagerIdAtom } from '@docpace/shared-react-atoms'

const typedManagerOverviewQueryDocument = ManagerOverviewQueryDocument as TypedDocumentNode<ManagerOverviewQueryResultFragment, Partial<ManagerOverviewQueryParams>>

export function useManagerOverviewQuery(opts?: useQuery.Options<ManagerOverviewQueryResultFragment, Partial<ManagerOverviewQueryParams>>){
    return useQuery(typedManagerOverviewQueryDocument, opts)
}

export function useContextManagerOverviewQuery(){
    const [ managerId ] = useAtom(ctxManagerIdAtom)
    const queryResult = useManagerOverviewQuery({
        variables: { managerId },
        skip: !managerId,
    })

    return {
        ...queryResult,
        manager: queryResult?.data?.manager
    }
}